<template>
    <RecommendedItem/>
</template>

<script>
    import RecommendedItem from 'components/landingpage/RecommendedItem'

    export default {
        components: { RecommendedItem },
    }
</script>
